<template>
  <div class="cbox">
    <div class="w_100 h_100 bcontent flexStart borderbox" style="padding:20px 0;">
      <div class="flex_1 h_100 flexCloumn" style="overflow:auto;">
      <div class="w_100 headbar flexStart" style="padding:0;border:0;">
        <el-button size="small"
                   type="primary"
                   plain
                   class="el-icon-download"
                   @click="downloadTJB"
        >导出技能鉴定统计表</el-button>
        <el-button size="small" type="primary" plain class="el-icon-download" @click="exportSummaryTable">导出总表</el-button>
      </div>
        <div style="width: 100%; background-color: #fff; border-radius: 4px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);">
          <div class="boxinner flexStart" style="">
            <img src="/img/home_title_icon.png" alt="" />
            <div class="boxtitle">
              各学校中职中级工持证率统计图
              <el-tag class="ml10 pointer" size="small" plain @click="exportChart('schoolsChart_1', '各学校中职中级工持证率统计图')">
                <i class="el-icon-download"></i>
                下载图表</el-tag
              >
            </div>
          </div>
          <div id="schoolsChart_1" style="height: 500px; width: 95%"></div>
        </div>

        <div class="mt20" style="width: 100%; background-color: #fff; border-radius: 4px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);">
          <div class="boxinner flexStart" style="">
            <img src="/img/home_title_icon.png" alt="" />
            <div class="boxtitle">
              各学校全体毕业生中职工持证率统计图
              <el-tag class="ml10 pointer" size="small" plain @click="exportChart('schoolsChart_2', '各学校全体毕业生中职工持证率统计图')">
                <i class="el-icon-download"></i>
                下载图表</el-tag
              >
            </div>
          </div>
          <div id="schoolsChart_2" style="height: 500px; width: 95%"></div>
        </div>

        <div class="mt20" style="width: 100%; background-color: #fff; border-radius: 4px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);">
          <div class="boxinner flexStart" style="">
            <img src="/img/home_title_icon.png" alt="" />
            <div class="boxtitle">
              各学校高职高级工持证率统计图
              <el-tag class="ml10 pointer" size="small" plain @click="exportChart('schoolsChart_3', '各学校高职高级工持证率统计图')">
                <i class="el-icon-download"></i>
                下载图表</el-tag
              >
            </div>
          </div>
          <div id="schoolsChart_3" style="height: 500px; width: 95%"></div>
        </div>

        <div class="mt20" style="width: 100%; background-color: #fff; border-radius: 4px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);">
          <div class="boxinner flexStart" style="">
            <img src="/img/home_title_icon.png" alt="" />
            <div class="boxtitle">
              各学校全体毕业生高级工持证率统计图
              <el-tag class="ml10 pointer" size="small" plain @click="exportChart('schoolsChart_4', '各学校全体毕业生高级工持证率统计图')">
                <i class="el-icon-download"></i>
                下载图表</el-tag
              >
            </div>
          </div>
          <div id="schoolsChart_4" style="height: 500px; width: 95%"></div>
        </div>

        <div class="mt20" style="width: 100%; background-color: #fff; border-radius: 4px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);">
          <div class="boxinner flexStart" style="">
            <img src="/img/home_title_icon.png" alt="" />
            <div class="boxtitle">
              各学校持证数量大于等于2的人数比例统计图
              <el-tag class="ml10 pointer" size="small" plain @click="exportChart('schoolsChart_5', '各学校持证数量大于等于2的人数比例统计图')">
                <i class="el-icon-download"></i>
                下载图表</el-tag
              >
            </div>
          </div>
          <div id="schoolsChart_5" style="height: 500px; width: 95%"></div>
        </div>
        <div class="mt20" style="width: 100%; background-color: #fff; border-radius: 4px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);">
          <div class="boxinner flexStart" style="">
            <img src="/img/home_title_icon.png" alt="" />
            <div class="boxtitle">
              各学校持证数量大于等于3的人数比例统计图
              <el-tag class="ml10 pointer" size="small" plain @click="exportChart('schoolsChart_6', '各学校持证数量大于等于3的人数比例统计图')">
                <i class="el-icon-download"></i>
                下载图表</el-tag
              >
            </div>
          </div>
          <div id="schoolsChart_6" style="height: 500px; width: 95%"></div>
        </div>
        <div class="mt20" style="width: 100%; background-color: #fff; border-radius: 4px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);">
          <div class="boxinner flexStart" style="">
            <img src="/img/home_title_icon.png" alt="" />
            <div class="boxtitle">
              各学校持证数量大于等于4的人数比例统计图
              <el-tag class="ml10 pointer" size="small" plain @click="exportChart('schoolsChart_7', '各学校持证数量大于等于4的人数比例统计图')">
                <i class="el-icon-download"></i>
                下载图表</el-tag
              >
            </div>
          </div>
          <div id="schoolsChart_7" style="height: 500px; width: 95%"></div>
        </div>
      </div>
    </div>

    <!--    查看-->
    <el-dialog class="cus_dialog " title="班级性质" :visible.sync="dialogVisible" :close-on-click-modal="false"
               width="600px" height="30%">
      <div style="line-height: 50px;">
        <a href="/xls/技能鉴定证书导入模板.xlsx" target="_blank">技能鉴定证书导入模板下载（excel/xls）</a>
      </div>
      <div style="line-height: 50px; color:orangered">
        请严格按照模板格式填入正确的数值
      </div>

      <div style="text-align:right">
<!--        <el-upload style="display: inline-block; margin-right: 20px;" action="" :http-request="uploadTemp"
                   :on-success="uploadFiles" :show-file-list="false" name="image" accept=".xls,.xlsx">
          <el-button icon="el-icon-upload" type="primary" style="margin-left:100px"
                     size="small">选择文件</el-button>
        </el-upload>-->
      </div>
    </el-dialog>
    </div>
</template>

<script>
import echartMixins from "../js/resizeMixins";
let colors = require("../home/com/color.js");
import html2canvas from "html2canvas";

export default {
  components: { },
  data() {
    return {
      dialogVisible: false,
      page: {
        count: 0,
        current_page: 1,
        per_page: 50,
        total_page: 0
      },
      dataList: [],
      showDialog_co: false,
      coList: [],
      indexCo: 0,
      // selectCoList:[],
      colorList: ['#67c23a', '#f56c6c', '#409eff',],
      majorTypes: [
        "农林牧渔大类",
        "资源环境与安全大类",
        "能源动力与材料大类",
        "土木建筑大类",
        "水利大类",
        "装备制造大类",
        "生物与化工大类",
        "轻工纺织大类",
        "食品药品与粮食大类",
        "交通运输大类",
        "电子与信息大类",
        "医药卫生大类",
        "财经商贸大类",
        "旅游大类",
        "文化艺术大类",
        "新闻传播大类",
        "教育与体育大类",
        "公安与司法大类",
        "公共管理与服务大类"
      ],
      timer: null,
    };
  },
  mounted() {
    // console.log(sessionStorage.getItem("auth"));
    //this.getSchoolList()
    //this.getStudentsTree()
    this.getData();
  },
  methods: {
    getData() {
      this.$http.post("/api/jnjd_cert_rate_count").then(res => {
        this.initEverSchools(res.data.data,res.data.avg)
      })
    },
    getInfo() {
      this.$http.post("/api/get_teacher_info").then(res => {
        this.teacherInfo = res.data
      })
    },
    exportChart(chartName, downloadName) {
      // let myChart = this.$echarts.getInstanceByDom(this.$refs.myChart);
      let myChart = this.$echarts.getInstanceByDom(document.getElementById(chartName));
      // 获取画布图表地址信息
      const imgUrl = myChart.getDataURL({
        type: "jpeg",
        pixelRatio: 1,
        backgroundColor: "#fff",
        excludeComponents: [
          //保存图表时忽略的工具组件,默认忽略工具栏
          "toolbox",
        ],
      });
      // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
      if (window.navigator.msSaveOrOpenBlob) {
        // 截取base64的数据内容（去掉前面的描述信息，类似这样的一段：data:image/png;base64,）并解码为2进制数据
        let bstr = atob(imgUrl.split(",")[1]);
        // 获取解码后的二进制数据的长度，用于后面创建二进制数据容器
        let n = bstr.length;
        // 创建一个Uint8Array类型的数组以存放二进制数据
        let u8arr = new Uint8Array(n);
        // 将二进制数据存入Uint8Array类型的数组中
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        // 创建blob对象
        let blob = new Blob([u8arr]);
        // 调用浏览器的方法，调起IE的下载流程
        window.navigator.msSaveOrOpenBlob(blob, downloadName + ".jpg");
      } else {
        //类似chrome浏览器创建一个a标签并使用a标签的href属性下载
        let tempA = document.createElement("a");
        tempA.download = downloadName + ".jpg";
        tempA.href = imgUrl;
        document.body.appendChild(tempA);
        tempA.click();
        tempA.remove();
      }
    },
    initEverSchools(resData,avg) {
      let dataAxis = [];
      let data = [];
      let option = {
        title: {
          text: "各个学校就业率统计图",
          left: "center",
          textStyle: {
            color: "white",
          },
        },
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {
              title: "下载图片", //鼠标滑过之后文案
              name: "我的图表", //图表名称
            },
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#fff",
            },
          },
        },
        grid: {
          top: "5%",
          left: "5%",
          right: "5%",
          bottom: "30%",
        },
        xAxis: {
          type: "category",
          data: dataAxis,
          axisPointer: {
            type: "shadow",
          },
          itemStyle: {
            color: function (params) {
              return colors[params.dataIndex];
            },
            borderRadius: [10, 10, 0, 0],
            shadowBlur: 1, // 设置阴影模糊度
            shadowColor: "rgba(255, 255, 255, 0.5)", // 设置阴影颜色
          },
          axisLabel: {
            textStyle: {
              color: "#000", // 设置 x 轴文字颜色
              fontWeight: "bold",
            },
            rotate: 45, // 旋转角度为45度
            formatter: function (value, index) {
              // 根据 value 或 index 自定义标签样式
              if (value == "中职中级工平均持证率") {
                return "{a|中职中级工平均}" + "{b|持证率}";
              }
              if (value == "中级工平均持证率") {
                return "{a|中级工平均}" + "{b|持证率}";
              }
              if (value == "高职高级工平均持证率") {
                return "{a|高职高级工平均}" + "{b|持证率}";
              }
              if (value == "高级工平均持证率") {
                return "{a|高级工平均}" + "{b|持证率}";
              }
              if (value == "大等于2平均持证率") {
                return "{a|大等于2平均}" + "{b|持证率}";
              }
              if (value == "大等于3平均持证率") {
                return "{a|大等于3平均}" + "{b|持证率}";
              }
              if (value == "大等于4平均持证率") {
                return "{a|大等于4平均}" + "{b|持证率}";
              }
              return value;
            },
            rich: {
              a: {
                color: "#f56c6c",
                // fontSize: 16,
                fontWeight: "bold",
              },
              b: {
                color: "#f56c6c",
                // fontSize: 16,
                fontWeight: "bold",
              },
            },
          },
        },
        yAxis: {
          type: "value",
          name: "百分比",
          splitLine: { show: false },
          // axisLabel: { color: '#fff' },
        },
        color: ["#6055BB", "#2469f3", "#cccc99", "#ff6666", "#cccc00", "#996699", "#333333"],
        series: [
          {
            type: "bar",
            barMaxWidth: 40,

            data: data,
            label: {
              show: true,
              position: "inside",
              // formatter: function (params) { //标签内容
              //   return params.value + '%'
              // },
            },
            itemStyle: {
              color: function (params) {
                if (params.name == "中职中级工平均持证率" || params.name == "中级工平均持证率" ||
                  params.name == "高职高级工平均持证率" || params.name == "高级工平均持证率" ||
                  params.name == '大等于2平均持证率' || params.name == '大等于3平均持证率' || params.name == '大等于4平均持证率') {
                  return "#f56c6c";
                }
              },
            },
          },
        ],
      };
      let myChart = null;
      option.title.text = "";
      option.grid.top = 50;
      option.tooltip.formatter = function (params) {
        let formaterstr = "",
          inner0 = "";
        inner0 = `<span>${params[0].value}%</span>`;
        formaterstr = inner0;
        // 这里去掉了 title，只保留了 series 名称和数据的描述
        return formaterstr;
      };
      resData.sort((a,b) => b.zz_zj_rate - a.zz_zj_rate)
      dataAxis = this._lo.map(resData,'school_name')
      dataAxis.unshift('中职中级工平均持证率')
      data = this._lo.map(resData,'zz_zj_rate')
      data.unshift(avg.zz_zj_rate)
      option.xAxis.data = dataAxis;
      option.series[0].data = data;
      option.toolbox.feature.saveAsImage.name = "各个学校中职中级工持证率统计图";
      myChart = this.$echarts.init(document.getElementById("schoolsChart_1"));
      myChart.setOption(option);

      resData.sort((a,b) => b.all_zj_rate - a.all_zj_rate)
      dataAxis = this._lo.map(resData,'school_name')
      dataAxis.unshift('中级工平均持证率');
      data = this._lo.map(resData,'all_zj_rate')
      data.unshift(avg.all_zj_rate)
      option.xAxis.data = dataAxis;
      option.title.text = "";
      option.series[0].data = data;
      option.toolbox.feature.saveAsImage.name = "各个学校中级工持证率统计图";
      myChart = this.$echarts.init(document.getElementById("schoolsChart_2"));
      myChart.setOption(option);

      resData.sort((a,b) => b.gz_gj_rate - a.gz_gj_rate)
      dataAxis = this._lo.map(resData,'school_name')
      dataAxis.unshift('高职高级工平均持证率');
      data = this._lo.map(resData,'gz_gj_rate')
      data.unshift(avg.gz_gj_rate)
      option.xAxis.data = dataAxis;
      option.title.text = "";
      option.series[0].data = data;
      option.toolbox.feature.saveAsImage.name = "各学校高职高级工持证率统计图";
      myChart = this.$echarts.init(document.getElementById("schoolsChart_3"));
      myChart.setOption(option);

      resData.sort((a,b) => b.all_gj_rate - a.all_gj_rate)
      dataAxis = this._lo.map(resData,'school_name')
      dataAxis.unshift('高级工平均持证率');
      data = this._lo.map(resData,'all_gj_rate')
      data.unshift(avg.all_gj_rate)
      option.xAxis.data = dataAxis;
      option.title.text = "";
      option.series[0].data = data;
      option.toolbox.feature.saveAsImage.name = "各学校全体毕业生高级工持证率统计图";
      myChart = this.$echarts.init(document.getElementById("schoolsChart_4"));
      myChart.setOption(option);

      resData.sort((a,b) => b.gte2_rate - a.gte2_rate)
      dataAxis = this._lo.map(resData,'school_name')
      dataAxis.unshift('大等于2平均持证率');
      data = this._lo.map(resData,'gte2_rate')
      data.unshift(avg.gte2_rate)
      option.title.text = "";
      option.xAxis.data = dataAxis;
      option.series[0].data = data;
      option.toolbox.feature.saveAsImage.name = "各学校持证数量大等于2的人数比例统计图";
      myChart = this.$echarts.init(document.getElementById("schoolsChart_5"));
      myChart.setOption(option);

      resData.sort((a,b) => b.gte3_rate - a.gte3_rate)
      dataAxis = this._lo.map(resData,'school_name')
      dataAxis.unshift('大等于3平均持证率');
      data = this._lo.map(resData,'gte3_rate')
      data.unshift(avg.gte3_rate)
      option.title.text = "";
      option.xAxis.data = dataAxis;
      option.series[0].data = data;
      option.toolbox.feature.saveAsImage.name = "各学校持证数量大等于3的人数比例统计图";
      myChart = this.$echarts.init(document.getElementById("schoolsChart_6"));
      myChart.setOption(option);

      resData.sort((a,b) => b.gte4_rate - a.gte4_rate)
      dataAxis = this._lo.map(resData,'school_name')
      dataAxis.unshift('大等于4平均持证率');
      data = this._lo.map(resData,'gte4_rate')
      data.unshift(avg.gte4_rate)
      option.title.text = "";
      option.xAxis.data = dataAxis;
      option.series[0].data = data;
      option.toolbox.feature.saveAsImage.name = "各学校持证数量大等于4的人数比例统计图";
      myChart = this.$echarts.init(document.getElementById("schoolsChart_7"));
      myChart.setOption(option);
    },
    downloadTJB() {
      //window.open('/xls/南京市职业学校2025届毕业生技能鉴定情况统计表.xlsx')
      const loadInstance = this.$loading({
        lock: true,
        text: '正在导出，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$http.post('/api/export_jnjdtjb_all').then(res => {
        this.timer = setInterval(() => {
          this.$http.get('/api/progress_status?progressKey=' + res.data.progressKey).then(r => {
            let data = r.data.data
            if (data.indexOf('http') > -1) {
              window.open(data,'_blank')
              clearInterval(this.timer)
              loadInstance.close()
            } else if (data == 'failed') {
              clearInterval(this.timer)
              loadInstance.close()
              this.$message.error('导出失败')
            }
          }).catch(() => {
            clearInterval(this.timer)
            loadInstance.close()
          })
        },3000)
      }).catch(() => {
        loadInstance.close()
      })
    },
    exportSummaryTable() {
      this.$http.post('/api/export_jnjdtjb_summary').then(res => {
        window.open(res.data.url,'_blank')
      })
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
};
</script>
<style type="text/less" lang="less" scoped>
.school {
  line-height: 30px;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px 10px;
}

.school:hover {
  background-color: aliceblue;

}

.ckd {
  background-color: #547df2;
  color: #fff;
}

.ckd:hover {
  background-color: #547df2;
  color: #fff;
}

.boxinner {
  padding: 30px 12px;
}

.boxtitle {
  height: 30px;
  padding-left: 10px;
  line-height: 30px;
  font-size: 20px;
  font-weight: 700;
}
</style>
